var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599609,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#3B5998"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5996 26C36.5996 20.48 32.1196 16 26.5996 16C21.0796 16 16.5996 20.48 16.5996 26C16.5996 30.84 20.0396 34.87 24.5996 35.8V29H22.5996V26H24.5996V23.5C24.5996 21.57 26.1696 20 28.0996 20H30.5996V23H28.5996C28.0496 23 27.5996 23.45 27.5996 24V26H30.5996V29H27.5996V35.95C32.6496 35.45 36.5996 31.19 36.5996 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/share-facebook.0ed77972e5ccacab8b6880de1e91eadf.svg";
export { ForwardRef as ReactComponent };